export const summaryOptions = {
  checkbox1: "Purpose of the Call",
  checkbox2: "Product or Service Discussion",
  checkbox3: "Customer's Sentiment",
  checkbox4: "Action items",
  checkbox5: "Oportunity Status",
  checkbox6: "Next Steps",
};
